import _ from "../../../../@lodash";

const CommentModel = (data) =>
  _.defaults(data || {}, {
    title: "",
    content: "",
    scope: "",
    status: "pending",
    review: "",
    approved: false,
    course: "",
    lesson: "",
    section: "",
    page: "",
    component: "",
    user: "",
  });

export default CommentModel;
